module.exports = __webpack_public_path__ + "img/pharmacy.d42e13b3.png";